const multipliers = {
  HUUM: 3.3,
  Harvia: 3.93,
  Saunum: 1.5,
};

const formatPrice = (number) =>
  number.toLocaleString("en-US", { minimumFractionDigits: 2 });

function isElementFullyVisible(el) {
  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

class Quiz {
  constructor() {
    this.quizTypes = [
      "general-inquiry",
      "heater-type",
      "mount-type",
      "pipe-type",
      "sauna-size",
      "cold-sf",
      "brand",
      "preference",
      "results",
    ];

    this.availableRoute = [
      "general-inquiry",
      "heater-type",
      "sauna-size",
      "cold-sf",
      "mount-type",
      "preference",
      "results",
    ];

    this.step = "general-inquiry";
    this.flow = [];

    this.cacheDOMElements();
    this.bindEvents();
    this.showStep();
    this.showProgress();
  }

  cacheDOMElements() {
    this.quizForm = document.querySelector("#quiz__form");
    this.sfDimContainer = document.querySelector("#sf-calc__dims");
    this.dimContainer = document.querySelector("#calc__dims");
    this.sfCuFeetInput = document.querySelector("#calc__sq-feet");
    this.cuFeetInput = document.querySelector("#calc__cu-feet");
    this.unitContainer = document.querySelector("#dimension-units");
    this.sfUnitContainer = document.querySelector("#sf-dimension-units");

    this.calcResults = document.querySelector("#calc_results");
    this.resultMain = document.querySelector("#results-main");

    this.prevButton = document.querySelector("#calc__prev-btn");
    this.nextButton = document.querySelector("#calc__next-btn");
    this.nextButtonTxt = document.querySelector("#next-btn__text");
    this.nextButtonImg = document.querySelector("#next-btn__img");
    this.resultsSection = document.querySelector("#sauna-heaters-section");
    this.resultsAddText = document.querySelector(
      "#sauna-heaters-additional-text",
    );
    this.resultsList = document.querySelector("#sauna-heaters-list");
  }

  bindEvents() {
    this.next = this.next.bind(this);
    this.prev = this.prev.bind(this);
    this.calculateVolume = this.calculateVolume.bind(this);
    this.calculateSF = this.calculateSF.bind(this);
    this.toggleUnits = this.toggleUnits.bind(this);
    this.sfToggleUnits = this.sfToggleUnits.bind(this);
    this.calculate = this.calculate.bind(this);
    this.resetCalculator = this.resetCalculator.bind(this);

    this.prevButton.addEventListener("click", this.prev);
    this.nextButton.addEventListener("click", this.next);
    this.dimContainer.addEventListener("input", this.calculateVolume);
    this.sfDimContainer.addEventListener("input", this.calculateSF);
    this.unitContainer.addEventListener("change", this.toggleUnits);
    this.sfUnitContainer.addEventListener("change", this.sfToggleUnits);
  }

  next() {
    // Fields: general-inquiry, heater-type, mount-type, pipe-type, depth, width, height, cu-feet-volume, sq-feet-surface, location, brand
    const quizFormData = new FormData(this.quizForm);
    this.flow.push(this.step);
    const choices = this.getChoices(quizFormData);

    const isValid = this.checkOptionSelection(this.step, choices);
    if (!isValid) return;

    switch (this.step) {
      case "general-inquiry":
        this.handleHelpStep(choices);
        break;
      case "heater-type":
        this.step = "sauna-size";
        break;
      case "sauna-size":
        this.handleSaunaSizeStep(choices);
        break;
      case "cold-sf":
        this.handleColdSfStep(choices);
        break;
      case "mount-type":
        this.step = "preference";
        break;
      case "preference":
      case "pipe-type":
      case "brand":
        this.calculate();
        this.step = "results";
        break;
      case "results":
        this.resetCalculator();
        return;
      default:
        break;
    }

    this.showStep();
    this.determinRoute();
    this.showProgress();
  }

  prev() {
    if (this.flow.length <= 0) return;

    if (this.step === "results") {
      this.resetResultsSection();
    }

    this.step = this.flow.pop();

    this.showStep();
    this.determinRoute();
    this.showProgress();
  }

  showProgress() {
    this.allRemoveProgressSteps();
    this.availableRoute.forEach((route) => {
      this.addProgressStep(
        route,
        this.flow.includes(route) || route === this.step,
      );
    });
  }

  determinRoute() {
    const quizFormData = new FormData(this.quizForm);
    const choices = this.getChoices(quizFormData);
    const generalInquiry = choices["general-inquiry"];
    const heaterType = choices["heater-type"];
    const cuFeetVolume = choices["cu-feet-volume"];

    if (generalInquiry === "size-my-heater")
      this.availableRoute = [
        "general-inquiry",
        "sauna-size",
        "cold-sf",
        "brand",
        "results",
      ];
    else {
      this.availableRoute = [
        "general-inquiry",
        "heater-type",
        "sauna-size",
        "cold-sf",
        "mount-type",
        "preference",
        "results",
      ];

      if (heaterType === "electric-sauna-heater") {
        if (cuFeetVolume > 1000)
          this.availableRoute = [
            "general-inquiry",
            "heater-type",
            "sauna-size",
            "cold-sf",
            "results",
          ];
      }

      if (heaterType === "wood-burning-stove")
        this.availableRoute = [
          "general-inquiry",
          "heater-type",
          "sauna-size",
          "cold-sf",
          "pipe-type",
          "results",
        ];
    }
  }

  checkOptionSelection(currentStep, choices) {
    const checkList = [
      "general-inquiry",
      "heater-type",
      "mount-type",
      "pipe-type",
      "preference",
    ];
    if (checkList.includes(currentStep)) {
      const selectedOption = choices[currentStep];
      if (!selectedOption) {
        this.setFeedback(
          `Please select an option for ${currentStep.replace("-", " ")}`,
          `#${currentStep}__feedback`,
        );
        return false;
      }
      this.setFeedback("", `#${currentStep}__feedback`);
      return true;
    }

    return true;
  }

  allRemoveProgressSteps() {
    const progressStepsContainer = document.getElementById("progress-steps");
    const steps = progressStepsContainer.querySelectorAll(".progress__step");
    const dividers =
      progressStepsContainer.querySelectorAll(".progress__divider");

    steps.forEach((step) => progressStepsContainer.removeChild(step));
    dividers.forEach((divider) => progressStepsContainer.removeChild(divider));
  }

  addProgressStep(step, isActive) {
    const progressStepsContainer = document.getElementById("progress-steps");
    const steps = document.querySelectorAll(".progress__step");

    let indicator = "00";
    if (steps.length < 10) {
      indicator = `0${steps.length + 1}`;
    } else {
      indicator = steps.length + 1;
    }

    // Create the step element
    const stepElement = document.createElement("div");
    stepElement.className = `progress__step ${
      isActive && "progress__step--active"
    } `;
    stepElement.innerHTML = `${indicator}`;

    progressStepsContainer.appendChild(stepElement);

    if (steps.length === 0) return;
    const divider = document.createElement("div");
    divider.className = "progress__divider";
    progressStepsContainer.insertBefore(divider, stepElement);
  }

  showStep() {
    this.quizTypes.forEach((type) => {
      const stepElement = document.getElementById(`quiz__step--${type}`);
      if (type === this.step) {
        stepElement.classList.remove("quiz__step--hidden");
      } else {
        stepElement.classList.add("quiz__step--hidden");
      }
    });

    const stepElement = document.getElementById(`quiz__step--${this.step}`);
    if (!isElementFullyVisible(stepElement)) {
      stepElement.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  toggleUnits() {
    this.toggleUnitInputs(this.dimContainer, "unit");
  }

  sfToggleUnits() {
    this.toggleUnitInputs(this.sfDimContainer, "sf-unit");
  }

  toggleUnitInputs(container, unitName) {
    const unitForm = new FormData(this.quizForm);
    const unit = unitForm.get(unitName);
    const depth = unitForm.get(`${unitName === "unit" ? "" : "sf-"}depth`);
    const width = unitForm.get(`${unitName === "unit" ? "" : "sf-"}width`);
    const height = unitForm.get(`${unitName === "unit" ? "" : "sf-"}height`);
    const depthInput = container.querySelector(
      `input[name="${unitName === "unit" ? "" : "sf-"}depth"]`,
    );
    const widthInput = container.querySelector(
      `input[name="${unitName === "unit" ? "" : "sf-"}width"]`,
    );
    const heightInput = container.querySelector(
      `input[name="${unitName === "unit" ? "" : "sf-"}height"]`,
    );

    const placeholders =
      unit === "Feet"
        ? ["Depth (ft)", "Width (ft)", "Height (ft)"]
        : ["Depth (in)", "Width (in)", "Height (in)"];
    [depthInput, widthInput, heightInput].forEach((input, index) =>
      input?.setAttribute("placeholder", placeholders[index]),
    );

    const conversionFactor = unit === "Feet" ? 1 / 12 : 12;
    [depthInput, widthInput, heightInput].forEach((input, index) => {
      const value = [depth, width, height][index];
      if (value) {
        input.value = Math.round(value * conversionFactor);
      }
    });
  }

  calculateVolume() {
    const dimForm = new FormData(this.quizForm);
    const depth = dimForm.get("depth");
    const width = dimForm.get("width");
    const height = dimForm.get("height");
    const unit = dimForm.get("unit");

    if ([depth, width, height].every((dim) => dim && !isNaN(+dim))) {
      const volume = depth * width * height;
      this.cuFeetInput.value =
        unit === "Feet" ? Math.round(volume) : Math.round(volume / 1728);
    }
  }

  calculateSF() {
    const dimForm = new FormData(this.quizForm);
    const width = dimForm.get("sf-width");
    const height = dimForm.get("sf-height");
    const unit = dimForm.get("sf-unit");

    if ([width, height].every((dim) => dim && !isNaN(+dim))) {
      const area = width * height;
      this.sfCuFeetInput.value =
        unit === "Feet" ? Math.round(area) : Math.round(area / 144);
    }
  }

  calculate() {
    const quizFormData = new FormData(this.quizForm);
    const choices = this.getChoices(quizFormData);
    console.log(choices);
    this.resultsList.innerHTML = "";
    this.resultsSection.style.display = "block";
    this.resultsAddText.innerHTML = "";
    this.nextButtonTxt.innerHTML = "Take Again";

    const coldSq = +choices["sq-feet-surface"] || 0;
    console.log(coldSq);
    const cuFeet = +choices["cu-feet-volume"];
    const brand = choices["brand"];
    const location = choices["location"];

    let coldAdder = coldSq * (multipliers[brand] ?? 1);

    const adjustedV = Math.ceil(coldAdder + cuFeet);
    const adjustedVHuum = Math.ceil(cuFeet + coldSq * multipliers["HUUM"]);
    const adjustedVHarvia = Math.ceil(cuFeet + coldSq * multipliers["Harvia"]);
    const adjustedVSaunum = Math.ceil(cuFeet + coldSq * multipliers["Saunum"]);

    this.displayResults(
      choices,
      cuFeet,
      brand,
      location,
      adjustedV,
      adjustedVHuum,
      adjustedVHarvia,
      adjustedVSaunum,
    );

    const queryParams = this.buildQueryParams(choices);
    this.fetchResults(queryParams);
  }

  displayResults(
    choices,
    cuFeet,
    brand,
    location,
    adjustedV,
    adjustedVHuum,
    adjustedVHarvia,
    adjustedVSaunum,
  ) {
    this.clearResultsSection();

    // Remove all children except the template element from the results container
    const container = document.querySelector(".results__container");
    Array.from(container.children).forEach((child) => {
      if (!child.tagName.toLowerCase().includes("template")) {
        container.removeChild(child);
      }
    });

    // Remove all children except the template element from the description container
    const descContainer = document.querySelector("#calc-description");
    Array.from(descContainer.children).forEach((child) => {
      if (!child.tagName.toLowerCase().includes("template")) {
        descContainer.removeChild(child);
      }
    });

    const commercialDescText =
      "We highly recommend reaching out to us for commercial projects. If you are working with a larger sauna soace, you might need a multi-heater setup. We also offer B2B pricing.";
    const generalDescText =
      "Your sauna heater should be sized based on the total adjusted volume of your sauna. This is the approximate range of heaters that could be suitable for your setup.";

    // Append the description template to the description container based on the general inquiry choice
    if (choices["general-inquiry"] === "commercial-project") {
      this.appendDescriptionTemplate(commercialDescText);
    } else {
      this.appendDescriptionTemplate(generalDescText);
    }
    /*
    if (!choices["sq-feet-surface"]) {
      // display volume if no cold surface area
      const volumeElement = this.resultMain.querySelector(".volume");
      if (volumeElement) {
        volumeElement.textContent = cuFeet;
      }
    }*/
    if (choices["general-inquiry"] === "size-my-heater") {
      // display result if size-my-heater route is selected
      this.showSizeMyHeaterResults(cuFeet, brand, location, adjustedV);
    } else {
      // display all brand results
      this.showGeneralResults(
        cuFeet,
        adjustedVHuum,
        adjustedVHarvia,
        adjustedVSaunum,
      );
    }
  }

  clearResultsSection() {
    this.resultsList.innerHTML = "";
    this.resultsSection.style.display = "block";
    this.resultsAddText.innerHTML = "";
  }

  showSizeMyHeaterResults(cuFeet, brand, location, adjustedV) {
    this.appendTemplate(
      `<span class="bold-text">Total volume of your sauna:</span> <span class="volume">${Math.ceil(
        cuFeet,
      )}</span> cubic feet`,
    );
    this.appendTemplate(
      `<span class="bold-text">Calculation done with:</span> <span class="calculation"> ${brand} Multiplier (${multipliers[brand]})`,
    );
    this
      .appendTemplate(`<span class="bold-text">Total adjusted volume of your sauna:</span>
      <span class="adjusted-volume">${adjustedV}</span> cubic feet`);

    this.resultMain.querySelector(".volume").textContent = adjustedV;
  }

  showGeneralResults(cuFeet, adjustedVHuum, adjustedVHarvia, adjustedVSaunum) {
    this.resultMain.classList.add("quiz__step--hidden");
    console.log("this runs");
    this.appendTemplate(
      `<span class="bold-text">Total volume of your sauna:</span> <span class="volume">${Math.ceil(
        cuFeet,
      )}</span> cubic feet`,
    );

    this
      .appendTemplate(`<span class="bold-text">Total adjusted volume of your sauna:</span>
                <span class="adjusted-volume">${adjustedVHuum}</span> cubic feet<span class="brand"> (HUUM)</span>`);

    this
      .appendTemplate(`<span class="bold-text">Total adjusted volume of your sauna:</span>
                  <span class="adjusted-volume">${adjustedVHarvia}</span> cubic feet<span class="brand"> (Harvia)</span>`);

    this
      .appendTemplate(`<span class="bold-text">Total adjusted volume of your sauna:</span>
      <span class="adjusted-volume">${adjustedVSaunum}</span> cubic feet<span class="brand"> (Saunum)</span>`);
  }

  appendTemplate(results) {
    const template = document.getElementById("result-template");
    const container = document.querySelector(".results__container");
    const clone = template.content.cloneNode(true);

    const element = clone.querySelector(`.calc-description`);
    if (element) {
      element.innerHTML = results;
    }

    container.appendChild(clone);
  }

  appendDescriptionTemplate(text) {
    const template = document.getElementById("calc-description-template");
    const container = document.querySelector("#calc-description");
    const clone = template.content.cloneNode(true);

    const element = clone.querySelector(`#calc-description-text`);
    if (element) {
      element.innerHTML = text;
    }

    container.appendChild(clone);
  }

  buildQueryParams(choices) {
    const typeMap = {
      "electric-sauna-heater": 0,
      "wood-burning-stove": 1,
    };

    const params = {};

    if (
      this.flow.includes("general-inquiry") &&
      choices["general-inquiry"] === "commercial-project"
    ) {
      params.commercial = "true";
    }
    if (this.flow.includes("heater-type")) {
      params.fuel = typeMap[choices["heater-type"]];
    }
    if (
      this.flow.includes("mount-type") &&
      choices["mount-type"] === "wall-mounted"
    ) {
      params.wall_mounted = true;
    }
    if (
      this.flow.includes("mount-type") &&
      choices["mount-type"] === "free-standing"
    ) {
      params.wall_mounted = false;
    }
    if (this.flow.includes("sauna-size")) {
      params.cubic_feet = choices["cu-feet-volume"];
    }
    if (this.flow.includes("cold-sf")) {
      params.cold_surface_area = choices["sq-feet-surface"] || 0;
    }
    if (this.flow.includes("preference")) {
      if (choices.preference === "luxury") {
        params.vendor = "HUUM,Saunum";
      } else if (choices.preference === "durability") {
        params.vendor = "Harvia";
      }
    } else if (this.flow.includes("brand")) {
      params.vendor = choices["brand"];
    }
    window.contactFormPayload = { answers: params };
    return new URLSearchParams(params).toString();
  }

  fetchResults(queryParams) {
    fetch(`https://api.thesaunaheater.com/quiz?${queryParams}`)
      .then((res) => res.json())
      .then((data) => this.displayHeaterData(data));
  }

  displayHeaterData(data) {
    const items = data.slice(0, 8).map(
      (heater) => `
    <a class="search-card" href="/products/${heater.handle}">
      <span class="search-card__media">
        <img loading="lazy" alt="" src="${heater.preview_image}">
      </span>
      <span class="search-card__body">
        ${heater.vendor ? `<span class="search-card__vendor text-body-xs-medium text-color-tertiary">${heater.vendor}</span>` : ""}
        <span class="search-card__title text-body-medium">${heater.title}</span>
        <span class="search-card__price text-body-medium">$${formatPrice(heater.price)}</span>
      </span>
    </a>
  `,
    );
    this.resultsList.innerHTML = items.join("");
  }

  resetCalculator() {
    this.flow = [];
    this.step = "general-inquiry";
    this.nextButtonTxt.innerHTML = "Next";
    this.resultsSection.style.display = "none";
    this.quizForm.reset();
    this.quizForm.scrollIntoView({ behavior: "smooth", block: "center" });
    this.showStep();
    this.determinRoute();
    this.showProgress();
  }

  setFeedback(value, selector) {
    const el = document.querySelector(selector);
    el.innerHTML = value;
    if (value) el.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  resetResultsSection() {
    this.nextButtonTxt.innerHTML = "Next";
    this.nextButtonImg.style.display = "block";
    this.resultsSection.style.display = "none";
    this.resultsList.innerHTML = "";
  }

  getChoices(formData) {
    const fields = [
      "general-inquiry",
      "heater-type",
      "mount-type",
      "pipe-type",
      "cu-feet-volume",
      "sq-feet-surface",
      "preference",
      "location",
      "brand",
    ];
    return fields.reduce(
      (acc, field) => ({ ...acc, [field]: formData.get(field) }),
      {},
    );
  }

  handleHelpStep(choices) {
    const stepMap = {
      "exploring-options": "heater-type",
      "commercial-project": "heater-type",
      "size-my-heater": "sauna-size",
    };
    this.step = stepMap[choices["general-inquiry"]] || this.step;
  }

  handleSaunaSizeStep(choices) {
    const volume = +choices["cu-feet-volume"];
    if (!volume || isNaN(volume)) {
      this.setFeedback(
        "Invalid or missing input for volume",
        "#cu-feet__feedback",
      );
      return;
    }

    if (volume < 80) {
      this.setFeedback("Provided values are too small", "#cu-feet__feedback");
      return;
    }

    if (volume > 1200) {
      this.setFeedback(
        "Max cubic feet 1200. If your sauna is larger, contact us for possible multiheater configuration",
        "#cu-feet__feedback",
      );
      return;
    }

    this.setFeedback("", "#cu-feet__feedback");
    this.step = "cold-sf";
  }

  handleColdSfStep(choices) {
    const square = +choices["sq-feet-surface"];
    const volume = +choices["cu-feet-volume"];

    if (isNaN(square) || square < 0) {
      this.setFeedback(
        "Invalid or missing input for square area",
        "#sq-feet__feedback",
      );
      return;
    }

    if (square > 100) {
      this.setFeedback(
        "Max square feet of cold surface 100. Your cold area is too large",
        "#sq-feet__feedback",
      );
      return;
    }

    this.setFeedback("", "#sq-feet__feedback");

    const isIncludeSteps = ["general-inquiry", "heater-type"].every((step) =>
      this.flow.includes(step),
    );

    const shouldCheckVolume =
      isIncludeSteps &&
      choices[this.flow[0]] === "commercial-project" &&
      choices[this.flow[1]] === "electric-sauna-heater";

    if (shouldCheckVolume && volume > 1000) {
      this.calculate();
      this.step = "results";
      return;
    }

    const stepMap = {
      "exploring-options":
        choices["heater-type"] === "electric-sauna-heater"
          ? "mount-type"
          : "pipe-type",
      "commercial-project":
        choices["heater-type"] === "electric-sauna-heater"
          ? "mount-type"
          : "pipe-type",
      "size-my-heater": "brand",
    };

    this.step = stepMap[choices["general-inquiry"]] || this.step;
  }
}

const parts = new Quiz();
